import React, { useState } from "react";
import { Check, ArrowRight } from "lucide-react";
import { subscribersApi } from "../../api";
import { useLang } from "../../context/LangContext";
import { toast } from "sonner";

export default function DealAlerts() {
  const { c } = useLang();
  const a = c.alerts;
  const [form, setForm] = useState({ first: "", last: "", email: "", freq: "Daily", states: "" });
  const [done, setDone] = useState(false);

  const submit = async () => {
    if (!form.email) { toast.error(c.toast.emailReq); return; }
    try {
      await subscribersApi.subscribe({ firstName: form.first, lastName: form.last, email: form.email, frequency: form.freq, states: form.states });
      setDone(true);
      toast.success(c.toast.subscribed);
    } catch (e) { toast.error(c.toast.subErr); }
  };

  return (
    <section id="alerts" className="section" style={{ background: "#0c0c0f" }}>
      <div className="container-x" style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "4rem", alignItems: "center" }}>
        <div className="reveal">
          <span className="eyebrow">{a.eyebrow}</span>
          <h2 className="display" style={{ fontSize: "clamp(2rem,4.5vw,3.6rem)", margin: "1.2rem 0 1.6rem" }}>
            {a.title.pre}<span className="italic-gold">{a.title.em}</span>{a.title.post}
          </h2>
          <p className="body-text" style={{ marginBottom: "2rem" }}>{a.para}</p>
          <div style={{ display: "grid", gap: "1rem" }}>
            {a.perks.map((p, i) => (
              <div key={i} style={{ display: "flex", gap: "0.8rem", alignItems: "center" }}>
                <span style={{ color: "var(--gold)" }}><Check size={16} /></span>
                <span style={{ color: "var(--text)", fontSize: "0.95rem" }}>{p}</span>
              </div>
            ))}
          </div>
        </div>

        <div className="card" style={{ padding: "2.6rem", background: "linear-gradient(180deg, rgba(201,162,75,0.05), transparent)" }}>
          {done ? (
            <div style={{ textAlign: "center", padding: "2rem 0" }}>
              <div style={{ width: 60, height: 60, borderRadius: "50%", background: "var(--gold-soft)", border: "1px solid var(--gold)", display: "flex", alignItems: "center", justifyContent: "center", margin: "0 auto 1.4rem", color: "var(--gold)" }}><Check size={28} /></div>
              <h3 className="font-serif" style={{ fontSize: "1.8rem", marginBottom: "0.6rem" }}>{a.doneTitle}</h3>
              <p className="body-text" style={{ fontSize: "0.9rem" }}>{a.donePara}</p>
            </div>
          ) : (
            <>
              <h3 className="font-serif" style={{ fontSize: "1.5rem", marginBottom: "1.6rem" }}>{a.formTitle}</h3>
              <div style={{ display: "grid", gap: "0.9rem" }}>
                <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: "0.7rem" }}>
                  <input className="field" placeholder={a.first} value={form.first} onChange={(e) => setForm({ ...form, first: e.target.value })} />
                  <input className="field" placeholder={a.last} value={form.last} onChange={(e) => setForm({ ...form, last: e.target.value })} />
                </div>
                <input className="field" placeholder={a.email} value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} />
                <select className="field" value={form.freq} onChange={(e) => setForm({ ...form, freq: e.target.value })}>
                  <option value="Daily">{a.freqDaily}</option><option value="Weekly">{a.freqWeekly}</option>
                </select>
                <input className="field" placeholder={a.states} value={form.states} onChange={(e) => setForm({ ...form, states: e.target.value })} />
                <button className="btn-gold" style={{ width: "100%" }} onClick={submit}>{a.submit} <ArrowRight size={14} /></button>
              </div>
            </>
          )}
        </div>
      </div>
    </section>
  );
}
